import { render, staticRenderFns } from "./PartnerHistory.vue?vue&type=template&id=04121a93"
import script from "./PartnerHistory.vue?vue&type=script&lang=js"
export * from "./PartnerHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports